const _excluded = ["children", "className"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "className", "mediaMatch"];
import "core-js/modules/es.array.iterator.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { useArchiveViewerContext, ArchiveViewerView } from "../context";
import useResizeObserver from 'use-resize-observer';
import { ViewerControlResponsiveOverlay } from "../controls";
import "./viewer-archive-container.style.scss";
export const ViewerArchiveContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('viewer-archive-container', className),
    ref: ref
  }, rest), children);
});
export const ViewerDocumentContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
  // TODO put grab scrollable logic here?
  // TODO if static video, put window layout dims as maximum ?
  const {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('viewer-archive-document-container', className),
    ref: ref
  }, rest), children);
});
export let ArchiveControlsView = /*#__PURE__*/function (ArchiveControlsView) {
  ArchiveControlsView[ArchiveControlsView["STATIC"] = 0] = "STATIC";
  ArchiveControlsView[ArchiveControlsView["RESPONSIVE"] = 1] = "RESPONSIVE";
  return ArchiveControlsView;
}({});
export const ArchiveControlsContext = /*#__PURE__*/React.createContext({
  view: ArchiveControlsView.STATIC
});
export const useArchiveControlsContext = () => React.useContext(ArchiveControlsContext);
export const ArchiveControlsProvider = props => {
  const {
    children,
    view
  } = props;
  return /*#__PURE__*/React.createElement(ArchiveControlsContext.Provider, {
    value: {
      view
    }
  }, children);
};
const controlsDefaultMediaMatch = 375;
export const ViewerControlsContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      children,
      className,
      mediaMatch = controlsDefaultMediaMatch
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const {
    controlsPortal,
    view
  } = useArchiveViewerContext();
  const {
    width = 0,
    ref: resizeRef
  } = useResizeObserver();
  const [controlsView, setControlsView] = React.useState(width < mediaMatch ? ArchiveControlsView.RESPONSIVE : ArchiveControlsView.STATIC);
  const setRefs = React.useCallback(node => {
    if (typeof ref === 'function') ref(node);else if (ref) ref.current = node;
    resizeRef(node);
  }, [resizeRef]);
  React.useEffect(() => {
    if (width) {
      if (width < mediaMatch) setControlsView(ArchiveControlsView.RESPONSIVE);else setControlsView(ArchiveControlsView.STATIC);
    }
    // console.log('WIDTH CHANGE: ',width)
  }, [width, mediaMatch]);
  const jsx = /*#__PURE__*/React.createElement(ArchiveControlsProvider, {
    view: controlsView
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('viewer-archive-controls-container', view === ArchiveViewerView.MODAL ? 'viewer-archive-controls-dialog-container' : 'viewer-archive-controls-static-container', className),
    ref: setRefs
  }, rest), controlsView === ArchiveControlsView.STATIC ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement("div", {
    className: "w-100 d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(ViewerControlResponsiveOverlay, null, children))));
  return controlsPortal ? /*#__PURE__*/ReactDOM.createPortal(jsx, controlsPortal) : jsx;
});